$(document).ready(function () {

    // Load More Case Studies Button functionality.

    // Define the options object with selectors and onSuccess callback.
    const caseStudiesAjaxOptions = {
        listSelector:       '.js-case-studies-wrapper',
        buttonsSelector:    '.case-studies__buttons',
        buttonsResponseKey: 'case_study_buttons',
        onSuccess:          triggerCaseStudiesCarousel,
    };

    // Filter posts by category
    $('.js-case-study-category').on('click', function () {
        var category = $(this).attr('data_slug');

        $('.js-case-study-category').removeClass('active');
        $(this).addClass('active');

        load_posts_ajax($('.js-view-more-case-studies'), {
            action: 'filter_case_studies',
            category: category
        }, 'replace', caseStudiesAjaxOptions);
    });

    // Load more posts
    $('.case-studies__buttons').on('click', '.js-view-more-case-studies', function () {
        var category = $('.js-case-study-category.active').attr('data_slug') || '';

        load_posts_ajax($(this), {
            action: 'load_more_case_studies',
            category: category
        }, 'append', caseStudiesAjaxOptions);
    });


    /*Carousel Blocks*/
    var slider = $('.js-case-studies-slider');
    var pagination = $('.js-case-studies-pagination');

    slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        pagination.text(i + '/' + (slick.$dots[0].children.length));
    });

    slider.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: "unslick"
            }
        ]
    });


    /* Featured Slider Block */
    const $featuredSlider = $('.js-featured-case-studies-slider');
    const $pagination = $('.js-featured-case-studies-pagination');
    const $paginationText = $pagination.find('.featured-case-studies-slider__pagination__text');

    $featuredSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
        if (!slick.$dots) {
            return;
        }

        const i = (currentSlide || 0) + 1;
        const totalSlides = slick.$dots[0].children.length;
        $paginationText.html(`${i}/${totalSlides}`);
    });

    $featuredSlider.slick({
        infinite: true,
        speed: 500,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        centerMode: true,
        // Was 15% - at narrow mobile widths that left the visible card too
        // short (aspect-ratio: 450/300 is width-driven) for its stacked
        // absolutely-positioned category tag + title + subtitle, which
        // overlapped/garbled on longer titles. A smaller peek gives the
        // card more width (and, via the fixed ratio, more height) to work
        // with; see _featured-case-studies-slider.scss for the rest of the
        // fix (font-size and .details cutoffs at small breakpoints).
        centerPadding: '6%',
        appendArrows: $pagination,

        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',

        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '8%'
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '4%'
                }
            }
        ]
    });

    /* Related Case Studies (single case study page) */
    // Reuses the featured slider's markup/CSS (featured-case-studies-slider__*
    // classes) but needs its own slick instance, not the shared
    // .js-featured-case-studies-slider one above: this section is always
    // exactly 3 cards (single.php caps posts_per_page at 3), and the shared
    // config's 1200px+ tier sets slidesToShow: 3 with centerMode - with
    // slidesToShow equal to the total slide count, slick's centered/infinite
    // clone math breaks and the third card wraps onto a bogus second row
    // instead of sitting beside the other two. Unslicking at 1200px+ instead
    // (matching .js-case-studies-slider's own convention above) falls back to
    // a plain 3-up CSS grid (_case-studies.scss) - there's no need for a
    // carousel when every card is already visible at once.
    const $relatedSlider = $('.js-related-case-studies-slider');
    const $relatedPagination = $('.js-related-case-studies-pagination');
    const $relatedPaginationText = $relatedPagination.find('.featured-case-studies-slider__pagination__text');

    $relatedSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
        if (!slick.$dots) {
            return;
        }

        const i = (currentSlide || 0) + 1;
        const totalSlides = slick.$dots[0].children.length;
        $relatedPaginationText.html(`${i}/${totalSlides}`);
    });

    $relatedSlider.slick({
        infinite: true,
        speed: 500,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '6%',
        appendArrows: $relatedPagination,

        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-left-blue.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.base_url + '/static/images/carousel-arrow-right-blue.svg" alt="next arrow"></div>',

        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '8%'
                }
            },
            {
                breakpoint: 1200,
                settings: "unslick"
            }
        ]
    });

    /*
     * Case Study Results Graph
     */

    // Align the graph header title with the chart area's left edge.
    // chart.chartArea.left accounts for y-axis label width dynamically,
    // so padding stays correct whether or not a y-axis label is set.
    var $canvas = $('.js-graph');
    if ($canvas.length) {
        var chart = Chart.getChart($canvas[0]);
        if (chart) {
            var header = $canvas[0].closest('.graph-interactive').querySelector('.graph-interactive__header');
            if (header) {
                header.style.paddingLeft = chart.chartArea.left + 'px';
            }
        }
    }

    
    // Isolate mode: clicking a legend item shows only that dataset and dims the others.
    // Clicking the active item again restores all datasets.
    // This approach also prevents an empty chart — at least one dataset is always visible.
    $(".js-graph-legend").find('.legend__item').on('click', function() {
        const chart = Chart.getChart($('.js-graph')[0]);
        if (!chart) return;

        const $items = $(".js-graph-legend").find('.legend__item');
        const clickedIndex = parseInt($(this).attr('data-index'));

        // Check if clicked dataset is already the only one visible (already isolated)
        const isIsolated = chart.data.datasets.every((_, i) =>
            i === clickedIndex ? chart.isDatasetVisible(i) : !chart.isDatasetVisible(i)
        );


        // If already isolated, restore all datasets and reset legend styles.
        if (isIsolated) {
            chart.data.datasets.forEach((_, i) => chart.show(i));
            $items.css('opacity', '1').removeClass('active');
        }
        // Otherwise, isolate the clicked dataset, dim and deactivate all others
        else {
            chart.data.datasets.forEach((_, i) => {
                if (i === clickedIndex) {
                    chart.show(i);
                } else {
                    chart.hide(i);
                }
            });
            $items.css('opacity', '0.4').removeClass('active');
            $(this).css('opacity', '1').addClass('active');
        }
    });

});